// config
import * as http from 'utils/http';
import config from 'config';
// utils

const getUsersToAssign = async () => {
  const data = await http.get(`${config.API_URL}price-negotiation/users/?page_size=500`);
  return data;
};

export default getUsersToAssign;
